var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1.8916V5.33372C11.6666 5.80043 11.6666 6.03378 11.7574 6.21204C11.8373 6.36885 11.9648 6.49633 12.1216 6.57622C12.2999 6.66705 12.5332 6.66705 12.9999 6.66705H16.442M13.3333 10.8337H6.66659M13.3333 14.167H6.66659M8.33325 7.50033H6.66659M11.6666 1.66699H7.33325C5.93312 1.66699 5.23306 1.66699 4.69828 1.93948C4.22787 2.17916 3.84542 2.56161 3.60574 3.03202C3.33325 3.5668 3.33325 4.26686 3.33325 5.66699V14.3337C3.33325 15.7338 3.33325 16.4339 3.60574 16.9686C3.84542 17.439 4.22787 17.8215 4.69828 18.0612C5.23306 18.3337 5.93312 18.3337 7.33325 18.3337H12.6666C14.0667 18.3337 14.7668 18.3337 15.3016 18.0612C15.772 17.8215 16.1544 17.439 16.3941 16.9686C16.6666 16.4339 16.6666 15.7338 16.6666 14.3337V6.66699L11.6666 1.66699Z",
    stroke: "#505050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.1b15180c6c5dbb37acd8b61ecefc3849.svg";
export { ForwardRef as ReactComponent };